import React from "react";
import { PORT_VIEW, PortHookInterface, editPortsHook, editPortsInterface, loggerListInterface } from "../portDetailsHook";
import WX_Fabricon from "../../../assets/images/wavexchange-small-icon.svg";
import Port from "./Port";

interface NodeProps {
  portProps: PortHookInterface;
  showTitle: boolean;
  isBandwidthPage: boolean;
}

const Node: React.FC<NodeProps> = ({ portProps, showTitle, isBandwidthPage }) => {
  const { portDetails: port } = portProps;
  if (!port) return <div>Loading...</div>;
  return (
    <div className="node-container-outer">
      <div className="node-container">
        <div className="title flex">
          {showTitle && port.ne_on_net ? <img src={WX_Fabricon} alt="on net" /> : ''}
          {showTitle && <p>{port.ne_name}</p>}
        </div>
        <Port isBandwidthPage={isBandwidthPage} portProps={portProps} />
      </div>
    </div>
  );
};
export default Node;
